import OTP from '../../../../../components/OTP';
import styles from './style.module.scss';

/** The verification code is numeric and exactly six digits long. */
const OTP_REGEX = /^([0-9]{0,})$/;

interface Props {
    /** Email address or phone number the code was sent to. */
    target: string;
    /** Label of the link that goes back to the form, e.g. "Change email". */
    changeText: string;
    otp: string;
    onOtpChange: (otp: string) => void;
    onChangeTarget: () => void;
};

/** Code entry step shared by the "edit email" and "edit phone number" modals. */
function VerificationStep({ target, changeText, otp, onOtpChange, onChangeTarget }: Props) {
    return (
        <div className={styles.confirm}>
            <span className={styles.description}>
                Enter the sent code to:
            </span>
            <div className={styles.detail}>
                <div className={styles.detail_target}>
                    <span>{target}</span>
                </div>
                <span
                    onClick={onChangeTarget}
                    className={styles.detail_change}
                >
                    {changeText}
                </span>
            </div>
            <OTP
                value={otp}
                numInputs={6}
                onChange={onOtpChange}
                onChangeRegex={OTP_REGEX}
            />
        </div>
    );
};

export default VerificationStep;
